import { ContentCopy, Edit } from '@workwave-tidal/core/icons'

import { preview } from '@/components/form/preview'
import { useCopyVoiceConfigModal } from '../../modals/CopyVoiceConfigModal'
import { AdvancedProperties } from './AdvancedProperties'

import { useVoiceData } from '../../hooks/useVoiceData'
import { useActions } from './hooks/useActions'
import { useTexts } from './hooks/useTexts'

interface Props {
  onEdit: () => void
}

export function VoiceView(props: Props) {
  const { onEdit } = props
  const [voice] = useVoiceData()
  const texts = useTexts()
  const actions = useActions()
  const isAdvanced = voice?.status === 'ADVANCED'
  const status = texts.value.status[voice?.status?.toLowerCase()] || 'OFF'
  const { Modal: CopyVoiceConfigModal } = useCopyVoiceConfigModal()

  return (
    <preview.Root
      testId="voice-view"
      applyPendingFitMapOnMount={false}
      rightBorder={false}
      header={
        <preview.Header title={texts.title} subtitle={texts.subtitle} testId="voice-view-header">
          <preview.ActionBar>
            <preview.ActionBarItem
              icon={<Edit />}
              onClick={onEdit}
              label={texts.actions.edit}
              disableWhenReadOnly={false}
              tooltip={texts.actions.edit}
              testId="setup-voice__edit"
              data-trackid="setup-voice__edit"
            />
            <preview.ActionBarItem
              icon={<ContentCopy />}
              onClick={actions.onCopy}
              label={texts.actions.copy}
              disableWhenReadOnly={false}
              tooltip={texts.actions.copy}
              testId="setup-voice__copy"
              data-trackid="setup-voice__copy"
            />
          </preview.ActionBar>
        </preview.Header>
      }
    >
      <preview.Field testId="voice-status" label={texts.labels.status}>
        {status}
      </preview.Field>

      {isAdvanced && <AdvancedProperties voice={voice} />}

      <CopyVoiceConfigModal />
    </preview.Root>
  )
}
